module.exports = __webpack_public_path__ + "media/images/pic/labels/materials/doki-doki-2-30f206415f8b164ad05b356a1eb23d50.jpg";